export default __webpack_public_path__ + "static/media/350px-Headshot.jpg.9682aee3.webp";